// Internal Imports
import { QUERY_STATSIG } from '../config/types/action.mjs';

// Local Functions
/**
 * State slice reducer for menu related actions.
 * @param {object}   state   menu state slice
 * @param {string}   type
 * @param {*}        payload
 * @returns {object}
 */
function statsigExperimentReducer(state = {}, { payload, type } = {}) {
  switch (type) {
    case QUERY_STATSIG:
      return {
        ...state,
        bucket: payload.bucket,
        error: payload.error,
        isInExperimentGroup: payload.isInExperimentGroup,
        isLoading: payload.isLoading,
        wasQueried: payload.wasQueried,
      };
    default:
      return state;
  }
}

// Module Exports
export { statsigExperimentReducer };
